// Keep the backend's precision; distinguish a valid zero from missing data.
export function displayQuote(value) {
  if (value == null || value === '' || !Number.isFinite(Number(value))) return '-';
  return value;
}

// Preserve metadata on partial updates and reuse unchanged rows/maps.
export function mergeSymbolQuotes(previous, incoming) {
  let result = previous;
  for (const [name, patch] of Object.entries(incoming || {})) {
    if (!patch || typeof patch !== 'object') continue;
    const current = previous[name];
    const keys = Object.keys(patch);
    if (current && keys.every(key => Object.is(current[key], patch[key]))) continue;
    if (result === previous) result = {...previous};
    result[name] = {...current, ...patch};
  }
  return result;
}
